import { createContext, Fragment, useCallback, useContext, useState, type ReactNode } from "react";
import { NavigationType, useLocation, useNavigationType } from "react-router-dom";

const RemountContext = createContext<() => void>(() => undefined);

export const RemountOnReportOpen = ({ children }: { children: ReactNode }) => {
  const [generation, setGeneration] = useState(0);
  const remount = useCallback(() => setGeneration((current) => current + 1), []);
  const { key } = useLocation();
  const navigationType = useNavigationType();
  const [shownKey, setShownKey] = useState(key);
  if (key !== shownKey) {
    setShownKey(key);
    if (navigationType === NavigationType.Pop) remount();
  }
  return (
    <RemountContext.Provider value={remount}>
      <Fragment key={generation}>{children}</Fragment>
    </RemountContext.Provider>
  );
};

export const useRemountList = () => useContext(RemountContext);
